import { VehicleType } from './type'
import { VehicleMake } from './make'
import { VehicleModel } from './model'
import { VehicleChargeSocketType } from './charge-socket-type'
import { VehicleStatus } from './vehicle-status'

export class Vehicle {
    id: string
    type: VehicleType
    make: VehicleMake
    model: VehicleModel
    regNo: string
    onboardPower?: number
    socketType?: VehicleChargeSocketType
    yearOfManufacturing?: number
    status?: VehicleStatus
    bookingsMade: number = 0

    constructor(id: string, type: VehicleType, make: VehicleMake, model: VehicleModel, regNo: string, onboardPower? : number, socketType ?: VehicleChargeSocketType, yearOfManufacturing? : number, status?: VehicleStatus, bookingsMade: number = 0) {
        this.id = id
        this.type = type
        this.make = make
        this.model = model
        this.regNo = regNo
        this.onboardPower = onboardPower
        this.socketType = socketType
        this.yearOfManufacturing = yearOfManufacturing
        this.status = status
        this.bookingsMade = bookingsMade
    }
}